import { components } from '@/types/strapi';
import { SingleColumnPopup, TwoColumnPopup } from './layouts';

interface InternalPopupContentProps {
	content: components['schemas']['SharedPopupContentComponent'];
}

export const InternalPopupContent = ({
	content,
}: InternalPopupContentProps) => {
	console.log('InternalPopupContent - Received content:', content);
	console.log('InternalPopupContent - Layout:', content?.layout);

	if (!content) {
		console.log('InternalPopupContent - Content is null or undefined');
		return null;
	}

	const { layout } = content;

	if (!layout) {
		console.log('InternalPopupContent - Layout is null or undefined');
		return null;
	}

	if (layout.startsWith('single')) {
		console.log('InternalPopupContent - Rendering SingleColumnPopup');
		return <SingleColumnPopup content={content} />;
	} else {
		console.log('InternalPopupContent - Rendering TwoColumnPopup');
		return <TwoColumnPopup content={content} />;
	}
};
